import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
import moment from 'moment'
import FirestoreUtils from 'src/plugins/Utils/FirestoreUtils'
import { firebase } from '@firebase/app'
import '@firebase/firestore'
const { Timestamp } = firebase.firestore
import { openURL } from 'quasar'
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: Array
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      value: this.modelProps ? this.modelProps : [],
      showDialog: false,
      dataDialog: {},
      chipShow: [],
      scaffolding: this.config.dialogScaffolding ? this.config.dialogScaffolding : {
        'item-1': {
          type: 'Select',
          label: 'Loại chứng từ',
          fieldName: 'documentType',
          datasource: {
            options: [],
            label: 'name',
            value: 'id'
          },
          validation: 'required'
        },
        'item-2': {
          type: 'FileInput',
          fieldName: 'file',
          validation: 'required',
          accept: this.config.accept
        }
      },
      header: this.config.header ? this.config.header : [
        {
          label: 'Tên file',
          format: 'file.name'
        },
        {
          format: 'file.documentType.name',
          label: 'Loại chứng từ'
        },
        {
          format: 'file.__sizeLabel',
          label: 'Dung lượng'
        },
        {
          format: 'file.hasOwnProperty(\'uploadDate\') ? this.convertDate(file.uploadDate) : \'\'',
          label: 'Ngày tải lên'
        }
      ],
      currentSize: 0,
      maxFileSize: this.config.maxFileSize || 80000000
    }
  },
  async created () {
    if(this.config.chipMode) {
      this.chipShow = this.value.map(item => !item['@deleted'])
    }
    await this.fetchDocumentType()
  },
  watch: {
    value: {
      handler: function () {
        this.$emit('input', this.value)
      },
      deep: true
    },
    modelProps: {
      handler: function (newValue) {
        this.value = newValue
      },
      deep: true
    }
  },
  computed: {
    validationRules () {
      return this.expressionResolver(this.config.validation)
    }
  },
  methods: {
    onBlur () {},
    readFile (file) {
      return new Promise((resolve) => {
        let reader = new FileReader()
        reader.onload = function () {
          resolve(reader.result)
        }
        reader.readAsBinaryString(file)
      })
    },
    async chooseFile (evt) {
      this.dataDialog.file = evt.target.files[0]
      this.addRow()
    },
    async addRow () {
      let vm = this
      if(this.config.maxNumFile && vm.value.filter(item => !item['@deleted']).length >= this.config.maxNumFile) {
        vm.$q.notify({
          message: `Bạn chỉ được upload 1 file`,
          color: "red",
          icon: "error"
        });
        return
      }
      if(this.config.chipMode) {
        this.pushFile()
      } else {
        await vm.$refs[`uploader-${vm._uid}`].validate().then(allTrue => {
          if (allTrue) {
            this.pushFile()
          }
        })
      }
    },
    pushFile() {
      let vm = this
      const readFile = vm.readFile(vm.dataDialog.file)
      Promise.all([readFile]).then(res => {
        this.currentSize +=vm.dataDialog.file.size
        if(this.currentSize >= this.maxFileSize) {
          this.$q.notify({
            message: `Dung lượng tải lên đã vượt quá mức cho phép, vui lòng kiểm tra lại`,
            html: true,
            color: "red",
            icon: "error",
            timeout: 7000
          })
        }
        const filePush = { 'binary': res, 'name': vm.dataDialog.file.name, '__sizeLabel': `${vm.dataDialog.file.size / 1000} Kb`, 'type': vm.dataDialog.file.type, 'documentType': vm.dataDialog.documentType }
        vm.value.push(filePush)
      }).catch(err => {
        console.log(err)
      })
      vm.showDialog = false
    },
    removeFile (file, index) {
      if (file.hasOwnProperty('@deleted') && file.hasOwnProperty('location')) {
        let index = this._.findIndex(this.value, file)
        if (index !== -1) {
          this.value[index]['@deleted'] = true
        }
      } else {
        this.value = this.R.remove(index, 1, this.value)
      }
    },
    getMoment () {
      return moment
    },
    async download (file) {
      let app = this._.get(this.config, ['app'])
      let storage = app === 'namis' ? this.$namis.storage() : this.$storage
      let linkDownload = await storage.ref(unescape(file.location)).getDownloadURL().catch(
        err => {
          this.$q.notify({
            message: 'Error ' + err.message.replace('Firebase Storage:', ''),
            color: 'red',
            icon: 'error'
          })
          return false
        })
      if (linkDownload) openURL(linkDownload)
    },
    convertDate (value) {
      if (!this.R.isNil(value) && !(value instanceof Timestamp)) {
        let converted = FirestoreUtils.convertJsonToTimetamp(value)
        return moment(converted instanceof Timestamp ? converted.toDate() : '')
          .format(this.$store.state.config.defaultDateFormat)
      }
      return moment(value.toDate()).format(this.$store.state.config.defaultDateFormat)
    },
    fetchDocumentType () {
      if(this.scaffolding['item-1'].datasource) {
        let vm = this
        return this.$query(['MasterData', 'DocumentType']).then(res => {
          vm.scaffolding['item-1'].datasource.options = res.list
        }).catch(err => { throw new Error(err) })
      }
    },
    formatString(evalStr, file) {
      return eval(evalStr)
    }
  }
}
